import styles from './UserDetails.module.scss';
import { API_URL } from '../../../../constants';
import { useParams } from 'react-router-dom';
import defaultAvatar from '../../../../assets/avatar.png';
import { useGetWithdrawRequest } from '../../../../hooks/useGetWithdrawRequest';
import { useGetUser } from '../../../../hooks/useGetUser';
import { CopyIco } from '../../../Shared/CopyIco/CopyIco';

interface IUserDetailsProps {
    userId: string;
    withdrawRequestId: string;
}

export const UserDetails = ({ userId, withdrawRequestId }: IUserDetailsProps) => {
    const { withdrawRequestData, isLoading: isLoadingWithdrawRequest } = useGetWithdrawRequest({
        id: withdrawRequestId,
    });
    const { userData, isLoading: isLoadingUserData } = useGetUser(userId);

    const isLoading = isLoadingWithdrawRequest && isLoadingUserData;

    if (isLoading || !userData || !withdrawRequestData) return null;

    return (
        <div className={styles.container}>
            <div className={styles.title}>User Details</div>
            <div className={styles.column}>
                <div className={styles.name}>Nickname</div>
                <div className={styles.value}>
                    {userData.nickName} <CopyIco value={userData.nickName ?? ''} />
                </div>
            </div>

            <div className={styles.column}>
                <div className={styles.name}>First Name</div>
                <div className={styles.value}>
                    {withdrawRequestData.firstName} <CopyIco value={withdrawRequestData.firstName ?? ''} />
                </div>
            </div>

            <div className={styles.column}>
                <div className={styles.name}>Last Name</div>
                <div className={styles.value}>
                    {withdrawRequestData.lastName} <CopyIco value={withdrawRequestData.lastName ?? ''} />
                </div>
            </div>

            {withdrawRequestData.cardMaskedPan ? (
                <div className={styles.column}>
                    <div className={styles.name}>Payout card</div>
                    <div className={styles.value}>
                        {withdrawRequestData.cardBrand ?? 'Card'} {withdrawRequestData.cardMaskedPan} ({withdrawRequestData.cardExpiration}){' '}
                        <CopyIco value={withdrawRequestData.cardMaskedPan ?? ''} />
                    </div>
                </div>
            ) : (
                <div className={styles.column}>
                    <div className={styles.name}>IBAN</div>
                    <div className={styles.value}>
                        {withdrawRequestData.iban} <CopyIco value={withdrawRequestData.iban ?? ''} />
                    </div>
                </div>
            )}
        </div>
    );
};
